/**
 * Represents the severity level of a log message.
 *
 * These levels can be used to filter or control logging output.
 */
export enum LogLevel {
  /**
   * Debug-level messages. Used for development and diagnostics.
   */
  Debug = "debug",

  /**
   * Error-level messages. Used for failures and unexpected conditions.
   */
  Error = "error",

  /**
   * Info-level messages. Used for general events.
   */
  Info = "info",

  /**
   * Disables logging
   */
  Off = "off",

  /**
   * Warning-level messages. Used for recoverable issues and unexpected non-fatal events.
   */
  Warning = "warning",
}
